import React from "react";
import { BaseLayout } from "@components/components";

export const WorkAreaBase = () => {
    return <BaseLayout full />;
};
